"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _formatPhoneNumber = _interopRequireDefault(require("./formatPhoneNumber"));

var _default = function _default(value, extension) {
  var phoneNumber = (0, _formatPhoneNumber.default)(value);
  return _I18n.default.text('i18n.numberRepresentation.phoneNumberWithExtension', {
    phoneNumber: phoneNumber,
    extension: extension
  });
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/utils/formatPhoneNumberWithExtension.js
// module id = 831
// module chunks = 209 210 211 212